export default __webpack_public_path__ + "static/media/income_and_benefits.e9ddfbb0.svg";